import { updateProductPrice } from "./product-card-update-price";
import { dimensionTableHandler } from "./dimension-table.js";
import { syncAddonQuantityToggle } from "./quantity-input";

export const observeQuickView = () => {
  if (document.documentElement.classList.contains("yith-quick-view-is-open")) {
    modifyQuickViewAsides();
    updateProductPrice();
    dimensionTableHandler();
    initQuickViewGallery();
    syncAddonQuantityToggle();
  }

  const targetNode = document.documentElement;
  const config = { attributes: true, attributeFilter: ["class"] };

  const callback = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "attributes") {
        if (
          document.documentElement.classList.contains("yith-quick-view-is-open")
        ) {
          modifyQuickViewAsides();
          dimensionTableHandler();
          initQuickViewGallery();
          syncAddonQuantityToggle();
          jQuery(document).ready(function ($) {
            $("form.variations_form").on(
              "found_variation",
              function (event, variation) {
                if (variation && variation.price_html) {
                  $(".woocommerce-variation-price").html(variation.price_html);
                }
              }
            );
          });
        }
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
};

// The quick view gallery is the same vertical, wheel-driven Splide as on the
// product page (markup comes from the `yith_wcqv_product_image_html` filter in
// functions.php). YITH replaces `div.images` on every colour change with an AJAX
// response, so this runs again on `qv_variation_gallery_loaded`. The modal is still
// animating open when the content lands, so the ResizeObserver re-measures the
// track once it has its final size (Splide's height: "100%" only measures at mount).
const initQuickViewGallery = () => {
  const root = document.querySelector(
    ".yith-quick-view-content .yith-qv-gallery"
  );

  if (!root || root.splide || typeof Splide === "undefined") {
    return;
  }

  const slidesCount = root.querySelectorAll(".splide__slide").length;

  const splide = new Splide(root, {
    type: "slide",
    direction: "ttb",
    height: "100%",
    perPage: 1,
    perMove: 1,
    drag: slidesCount > 1,
    wheel: slidesCount > 1,
    wheelSleep: 500,
    releaseWheel: true,
    arrows: false,
    pagination: slidesCount > 1,
    rewind: false,
    speed: 800,
  });
  splide.mount();

  let frame = null;
  const resizeObserver = new ResizeObserver(() => {
    if (!root.isConnected) {
      resizeObserver.disconnect();
      return;
    }
    if (frame) return;
    frame = requestAnimationFrame(() => {
      splide.refresh();
      frame = null;
    });
  });
  resizeObserver.observe(root);
};

if (!window.smartwoodQuickViewGalleryBound) {
  window.smartwoodQuickViewGalleryBound = true;
  jQuery(document).on(
    "yith_quick_view_loaded qv_variation_gallery_loaded",
    initQuickViewGallery
  );
}

const modifyQuickViewAsides = () => {
  setTimeout(() => {
    const quickViewContent = document.querySelector(".yith-quick-view-content");

    if (quickViewContent) {
      const asideOpenElements =
        quickViewContent.querySelectorAll("[data-aside-open]");
      asideOpenElements.forEach((element) => {
        const currentValue = element.getAttribute("data-aside-open");
        if (!currentValue.includes("--quickview")) {
          element.setAttribute("data-aside-open", `${currentValue}--quickview`);
        }
      });
    }
  }, 500);
};
